import { Fragment } from 'react/jsx-runtime';

import { useGetTickets } from '../hooks';

// import { UsersListError } from './UsersListError';
// import { UsersListLoading } from './UsersListLoading';
import { TicketsTableRow } from './TicketsTableRow';
import { Ticket } from '../types';
// import { UsersListStatus } from './UsersListStatus';

const data: Ticket[] = [
  {
    id: '1',
    ticket: 'John Doe',
    price: 'sample@gmail.com',
    seats: '12',
    schedule: '2023-10-01T12:00:00Z',
    status: 'active',
  },
];

export const TicketsList = () => {
  const ticketsQuery = useGetTickets();

  //   if (ticketsQuery.isLoading) return <UsersListLoading />;

  //   if (ticketsQuery.data && ticketsQuery.data.data.length === 0)
  //     return <UsersListStatus />;

  //   if (ticketsQuery.isError)
  //     return <UsersListError refetch={ticketsQuery.refetch} />;

  return (
    <Fragment>
      {/* {ticketsQuery.data &&
        ticketsQuery.data.data.map((user, index) => {
          return <TicketsTableRow key={index} {...user} />;
        })} */}
      {data.map((user, index) => {
        return <TicketsTableRow key={index} {...user} />;
      })}
    </Fragment>
  );
};
